import { __ } from '@wordpress/i18n';
import { useState } from 'react';
import { updateOption } from '../../helper/axios';
import SaveButton from './save-button';
import { ThemeBuilderSelectSearch } from 'jkit-core/control';
import { searchPages } from './helper';


const NotFound = ({ setSnackbar }) => {
    const { notFoundTemplate } = window['JkitDashboardOption'];
    const [isSave, setIsSave] = useState(false);
    const [isSaved, setIsSaved] = useState(false);
    const [value, setValue] = useState(notFoundTemplate);
    const saveOption = async () => {
        const params = {
            option_name: 'jkit_notfound_template',
            options: value,
            auto_load: false
        }
        await updateOption(params).then(res => {
            if (res) {
                setIsSaved(true);
                window['JkitDashboardOption'].notFoundTemplate = value;
                setSnackbar(__('Change Saved', 'jeg-elementor-kit'));
            } else {
                setSnackbar(__('Saved Failed', 'jeg-elementor-kit'));
            }
            setTimeout(() => {
                setIsSaved(false);
                setIsSave(false);
            }, 1000);
        });
    };

    const updateValue = (id, value) => {
        setValue(value)
    }
    return (
        <div className="content-wrapper general">
            <h3>{__('Choose 404 Template', 'jeg-elementor-kit')}</h3>
            <div className='control-wrapper'>
                <ThemeBuilderSelectSearch
                    id={'404-notfound'}
                    value={value}
                    onSearch={searchPages}
                    updateValue={updateValue}
                    multiple={false}
                    inputKey={`404-notfound`}
                />
                <SaveButton isSaved={isSaved} isSave={isSave} onSave={saveOption} />
            </div>
            <span className='option-desc'>{__('Choose which page that you want to set as a 404 page.', 'jeg-elementor-kit')}</span>
        </div>
    );
};

export default NotFound;
